import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

gsap.defaults({ ease: "power3" });
gsap.set(".stagger", { y: 50 });

const showMoreButton = document.querySelector("#show-more");

if (showMoreButton) {
  showMoreButton.addEventListener("click", () => {
    const staggerItems = Array.from(document.querySelectorAll(".stagger--hidden")).splice(0, 8);

    staggerItems.forEach((item) => {
      item.classList.remove("stagger--hidden");
    });
    ScrollTrigger.batch(staggerItems, {
      start: "top 80%",
      onEnter: (batch) => gsap.to(batch, { opacity: 1, y: 0, stagger: { each: 0.15 }, overwrite: true }),
    });

    // Hide showMoreButton if there are no more items to show
    if (staggerItems.length <= 8) {
      showMoreButton.style.display = "none";
    }
  });
}

ScrollTrigger.batch(".stagger.stagger--initial", {
  start: "top 80%",
  onEnter: (batch) => gsap.to(batch, { opacity: 1, y: 0, stagger: { each: 0.15 } }),
});
